<template>
  <page-listado>
    <page-header title="Contratos">
      <busqueda-rapida />
    </page-header>
    <filtros-contratos :filtros="$route.query" @filtrar="filtrar" />
    <tabla :contratos-clientes="resultado.contratosClientes" @eliminar="eliminar" @renovar="renovar" />
    <b-row class="mt-4">
      <b-col>
        <paginacion
          :page-count="parseInt(resultado.numeroPaginas)"
          :page="parseInt(resultado.pagina)"
          :total-items="parseInt(resultado.totalItems)"
        />
      </b-col>
    </b-row>
  </page-listado>
</template>

<script>
import { mapState } from "pinia";
import { useSessionStore } from "@/stores/SessionStore";
import contratosClienteApi from "@/services/contratosCliente.js";
import Tabla from "./TablaContratosCliente.vue";
import FiltrosContratos from "./FiltrosContratos.vue";

export default {
  components: { Tabla, FiltrosContratos },
  data() {
    return {
      resultado: {
        contratosClientes: [],
        numeroPaginas: 0,
        pagina: 1,
      },
    };
  },
  methods: {
    async listar() {
      return contratosClienteApi
        .listarContratosDeCliente(this.$route.params.id, this.$route.query)
        .then((resultado) => {
          this.resultado = resultado;
        });
    },
    async eliminar(id) {
      await contratosClienteApi.eliminar(id);
      this.listar();
    },
    async renovar(id) {
      var data = await contratosClienteApi.renovar(id);
      var ofertaId = data.data;
      this.$router.push("/ofertas/editar/" + ofertaId);
    },
    filtrar(data) {
      this.$router
        .push({
          path: this.$route.path,
          query: data,
        })
        .catch((err) => err);
    },
  },
  computed: {
    ...mapState(useSessionStore, ["esAdmin"]),
  },
  watch: {
    "$route.params": {
      handler: function () {
        this.listar();
      },
      deep: true,
      immediate: true,
    },
  },
};
</script>
